module.exports = __webpack_public_path__ + "img/ug514.0af5c22e.png";